import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
    selector: 'brightside-web-pls-intro',
    templateUrl: './pls-official-rules.component.html',
    styleUrls: ['./pls-official-rules.component.scss'],
    standalone: false
})
export class PlsOfficialRulesComponent {
  constructor(private _location: Location) {}

  backToIntro(): void {
    this._location.back();
  }
}
